import Vuex from 'vuex'
import Vue from 'vue'

import entradas from './modules/entradas'
import categorias from './modules/categorias'


Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: { entradas, categorias }
})